const SNAPSHOT_EXITED_STATUS = "16";

export function normalizeCustomerWarehouseId(value) {
  if (value === undefined || value === null) return "";
  const normalized = String(value).trim();
  return normalized && normalized !== "-" ? normalized : "";
}

function firstValidId(...values) {
  for (const value of values) {
    const normalized = normalizeCustomerWarehouseId(value);
    if (normalized) return normalized;
  }
  return "";
}

// DİKKAT: snapshot status=0, backend'de "bu oda operasyondan ÇIKARILDI" (silindi) demektir
// (operations::update tamamlamada eşleşmeyen odaları 0 yapar). Panelde 0'ı "Tamamlandı"
// saymak, silinen odayı aktif oda gibi göstermeye ve fiyat listesinde dolu tutmaya yol
// açıyordu. Tamamlanmış giriş satırının statüsü 1'dir.
function isCompletedStatus(status) {
  const code = String(status ?? "").trim();
  const lowered = code.toLowerCase();
  return code === "1" || lowered === "tamamlandı" || lowered === "tamamlandi";
}

function resolveSnapshotCustomerId(snapshot) {
  return firstValidId(
    snapshot?.customerID,
    snapshot?.customerId,
    snapshot?.customer_id,
    snapshot?.userID,
    snapshot?.userId,
    snapshot?.user_id
  );
}

// YETKİLİ OLUNAN ODA: BE, sahibi görüntüleyen kişi OLMAYAN odalara owner_name ve
// authorized_permissions ekler. Kendi deposu olmayan ama bir odaya yetkilendirilmiş
// müşteride bu satırlar da "depo girişi var" sayılmalı; aksi halde sidebar'da
// "Depo Bilgilerim" hiç görünmüyordu (bkz. pageConfig customerHasWarehouseEntry filtresi).
function isAuthorizedSnapshot(snapshot) {
  return Boolean(
    snapshot?.ownerName ||
    snapshot?.owner_name ||
    snapshot?.authorizedPermissions ||
    snapshot?.authorized_permissions
  );
}

// Aktif (Tamamlandı) ya da Pasif (16) statüsünde en az bir depo girişi snapshot'ı var mı?
// "Onay Bekleniyor"/"Gerçekleşecek" gibi ara statüler Depo Bilgilerim sayfasında gösterilecek
// bir oda kartı üretmediğinden sayılmaz — [[warehouseRoomOccupancy]]'deki admin tarafı
// (customerIdsWithAnyEntry) ile aynı tanım.
// TEKLİF ONAYLANDI, OPERASYON HENÜZ TAMAMLANMADI — bu aralıkta snapshot YOKTUR ama
// "Depo Bilgilerim" açılmalıdır (kullanıcı kararı): müşteri onayladığı depoyu görebilsin.
// Kural, MyWarehousesPage'teki buildPendingOperationCards ile AYNI olmalı:
//   • operations.type === "operation" (warehouse-exit / feasibility / warehouse-visit değil)
//   • statü iptal (4) ya da tamamlanmış (1/0) değil
//   • talep tipi new-storage — `operations.type` ayırt etmez, hepsi "operation"dur
// Teklifte depo seçilmiş olması ARANMAZ: kartın deposu öncelikle operasyonun bekleyen
// snapshot'ından çözülür (teklif yalnızca yedek kaynaktır), dolayısıyla teklif JSON'unu
// şart koşmak menüyü kart varken kapalı bırakabilirdi.
export function hasPendingCustomerWarehouseOperation(operations) {
  if (!Array.isArray(operations)) return false;
  return operations.some((op) => {
    if (!op || typeof op !== "object") return false;
    if (String(op.type || "").trim() !== "operation") return false;
    const statusCode = String(op.status ?? "").trim();
    if (statusCode === "4" || statusCode === "0" || isCompletedStatus(statusCode)) return false;
    const requestType = String(op?.offerDetails?.requestDetails?.type || "").trim();
    return requestType === "new-storage";
  });
}

export function hasCustomerWarehouseEntry(snapshots, customerID) {
  const normalizedCustomerID = normalizeCustomerWarehouseId(customerID);
  if (!normalizedCustomerID || !Array.isArray(snapshots)) return false;

  return snapshots.some((snapshot) => {
    if (String(snapshot?.type || "").trim() !== "operation") return false;

    const statusCode = String(snapshot?.status ?? "").trim();
    if (statusCode !== SNAPSHOT_EXITED_STATUS && !isCompletedStatus(statusCode)) return false;

    return resolveSnapshotCustomerId(snapshot) === normalizedCustomerID || isAuthorizedSnapshot(snapshot);
  });
}
